import { type ReactNode } from "react";

// 폼 필드 래퍼: 라벨은 항상 인풋 위, helper 와 error 는 항상 인풋 아래에 온다.
// placeholder 를 라벨 대신 쓰지 않는다 (값이 채워지면 무슨 칸인지 알 수 없어진다).
export default function Field({
  label,
  helper,
  error,
  className = "",
  children,
}: {
  label: string;
  helper?: ReactNode;
  error?: string | null;
  className?: string;
  children: ReactNode;
}) {
  return (
    <label className={`flex flex-col gap-1.5 ${className}`}>
      <span className="text-xs font-medium text-slate-600">{label}</span>
      {children}
      {/* 오류가 있으면 helper 를 덮는다. 두 줄이 동시에 뜨면 어느 쪽을 읽어야 할지 모호해진다 */}
      {error ? (
        <span className="text-xs text-rose-600">{error}</span>
      ) : helper ? (
        <span className="text-xs text-slate-500">{helper}</span>
      ) : null}
    </label>
  );
}
